<template>
  <v-dialog
    v-model="isOpen"
    @keydown.esc="close"
    persistent
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Save page as template</span>
      </v-card-title>

      <v-card-text>
        <v-container class="container">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                v-model="editedItem.name"
                label="Template name"
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div id="error" class="red--text text-center">
        {{ errorMessage }}
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-close" class="btn-secondary" @click="close">
          Cancel
        </v-btn>
        <v-btn id="btn-ok" class="btn-primary" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogTemplateSave',
  props: {
    isOpen: Boolean,
    editedItem: Object,
    errorMessage: String
  },
  methods: {
    close() {
      this.$emit('close', null)
    },

    save() {
      this.$emit('save', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 130px;
}
</style>
